<template>
  <div class="row">
    <slot :items="items"></slot>
    <div class="col-lg-4 col-md-6 col-sm-12 grid-sizer"></div>
  </div>
</template>

<script>
import Isotope from 'isotope-layout'
import imagesloaded from 'imagesloaded'
import $ from 'cash-dom'

const isMobile = Math.min(window.screen.width, window.screen.height) < 768 || navigator.userAgent.indexOf("Mobi") > -1;

const initIsotope = (el) => {
  return new Isotope( el, {
    // options...
    itemSelector: '.article__col',
    masonry: {
      columnWidth: '.grid-sizer'
    }
  })
}

export default {
  props: {
    items: Array,
  },
  data () {
    return {
      iso: null
    }
  },
  watch: {
    items () {
      this.$nextTick(() => {
        if (isMobile) {
          $(this.$el).find('.article__col:not(.appear)').addClass('appear')
          return
        }

        imagesloaded(this.$el, () => {
          if (this.iso) {
            this.iso.layout()
            this.iso.appended($(this.$el).find('.article__col:not(.appear)').addClass('appear'))
          } else {
            this.iso = initIsotope(this.$el)
            this.iso.revealItemElements($(this.$el).find('.article__col').addClass('appear'))
          }
        })
      })
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (isMobile) {
        $(this.$el).find('.article__col:not(.appear)').addClass('appear')
        return
      }
      
      imagesloaded(this.$el, () => {
        imagesloaded(this.$el, () => {
          if (document?.fonts?.ready) {
            document.fonts.ready.then(() => {
              this.iso = initIsotope(this.$el)
              this.iso.revealItemElements($(this.$el).find('.article__col').addClass('appear'))
            })
          } else {
            this.iso = initIsotope(this.$el)
            this.iso.revealItemElements($(this.$el).find('.article__col').addClass('appear'))
          }
        })
      })
    })
  }
}
</script>